import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import BusinessLine from './BusinessLine'

/**
 * Branže
 */
export default class TPartnerBusinessLineDM extends Data {
	public static className = 'TPartnerBusinessLineDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * AuxiliaryRID
	 */
	AuxiliaryRID?: number

	/**
	 * MasterRID
	 */
	MasterRID?: number

	/**
	 * Typ
	 */
	LinkTypeId?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * SlaveRID
	 */
	@Type(() => BusinessLine)
	SlaveRID?: BusinessLine
}